<template>
  <div class="room dehumidifier-small" v-loading="loadingData">
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagLeft">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLineOpts" :series="humidityLineData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityBarOpts" :series="humidityBarData"></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleLeft1" :series="switchDataLeft1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleLeft2" :series="switchDataLeft2"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleLeft3" :series="switchDataLeft3"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleLeft4" :series="switchDataLeft4"></SwitchStatus>
          <RunningTimeBig class="device-block-time-left" :title="runningTimeTitleLeft" :series="runningTimeDataLeft" :isHour="true"></RunningTimeBig>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleRight1" :series="switchDataRight1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleRight2" :series="switchDataRight2"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleRight3" :series="switchDataRight3"></SwitchStatus>
          <RunningTimeBig
            class="device-block-time-right"
            :title="runningTimeTitleRight"
            :series="runningTimeDataRight"
            :isHour="true"
          ></RunningTimeBig>
        </div>
      </div>
    </div>

    <div class="device-block-multi">
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOpts1"
        :series="singlePieHistogramWrapData1"
        :class="warningFlag1"
      ></SinglePieHistogramWrap>
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOpts2"
        :series="singlePieHistogramWrapData2"
        :class="warningFlag2"
      ></SinglePieHistogramWrap>
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOpts3"
        :series="singlePieHistogramWrapData3"
        :class="warningFlag3"
      ></SinglePieHistogramWrap>
      <SinglePieHistogramWrap
        class="device-block-multi-item"
        :opts="singlePieHistogramWrapOpts4"
        :series="singlePieHistogramWrapData4"
        :class="warningFlag4"
      ></SinglePieHistogramWrap>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/towerConfig.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      warningFlagLeft: "",
      warningFlagRight: "",
      deviceList: [],
      singlePieHistogramWrapData1: null,
      singlePieHistogramWrapData2: null,
      singlePieHistogramWrapData3: null,
      singlePieHistogramWrapData4: null,
      warningFlag1: "",
      warningFlag2: "",
      warningFlag3: "",
      warningFlag4: "",
      humidityLineData: null,
      humidityBarData: null,
      switchDataLeft1: null,
      switchDataLeft2: null,
      switchDataLeft3: null,
      switchDataLeft4: null,
      switchDataRight1: null,
      switchDataRight2: null,
      switchDataRight3: null,
      runningTimeDataLeft: null,
      runningTimeDataRight: null,
    };
  },
  computed: {
    singlePieHistogramWrapOpts1: function () {
      return {
        title: this.stationName + "塔内温湿度1",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOpts2: function () {
      return {
        title: this.stationName + "塔内温湿度2",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOpts3: function () {
      return {
        title: this.stationName + "塔内温湿度3",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOpts4: function () {
      return {
        title: this.stationName + "塔内温湿度4",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },

    humidityLineOpts: function () {
      return {
        title: this.stationName + "除湿机温湿度",
        legend1: "除湿机湿度",
        legend2: "除湿机温度",
      };
    },
    humidityBarOpts: function () {
      return {
        title: "除湿机温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },

    switchTitleLeft1: function () {
      return "除湿机运行";
    },
    switchTitleLeft2: function () {
      return "风机运行";
    },
    switchTitleLeft3: function () {
      return "平均/最差控制";
    },
    switchTitleLeft4: function () {
      return "手动/自动选择";
    },
    runningTimeTitleLeft: function () {
      return "除湿运行时间";
    },

    switchTitleRight1: function () {
      return "除湿机故障";
    },
    switchTitleRight2: function () {
      return "风机故障";
    },
    switchTitleRight3: function () {
      return "远程/就地选择";
    },

    runningTimeTitleRight: function () {
      return "风机运行时间";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        this.setPieHistogramDataAndError(currentData, "humidityBarData", "除湿机温度", "除湿机湿度", "warningFlagLeft");

        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData1", "塔内温度1", "塔内湿度1", "warningFlag1");
        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData2", "塔内温度2", "塔内湿度2", "warningFlag2");
        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData3", "塔内温度3", "塔内湿度3", "warningFlag3");
        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData4", "塔内温度4", "塔内湿度4", "warningFlag4");

        const switchIdLeft1 = this.findDeviceId(this.switchTitleLeft1);
        const switchIdLeft2 = this.findDeviceId(this.switchTitleLeft2);
        const switchIdLeft3 = this.findDeviceId(this.switchTitleLeft3);
        const switchIdLeft4 = this.findDeviceId(this.switchTitleLeft4);
        this.switchDataLeft1 = {
          data: currentData[switchIdLeft1].value,
          isError: currentData[switchIdLeft1].errorLevel,
        };
        this.switchDataLeft2 = {
          data: currentData[switchIdLeft2].value,
          isError: currentData[switchIdLeft2].errorLevel,
        };
        this.switchDataLeft3 = {
          data: currentData[switchIdLeft3].value,
          isError: currentData[switchIdLeft3].errorLevel,
          textOn: "最差",
          textOff: "平均",
        };
        this.switchDataLeft4 = {
          data: currentData[switchIdLeft4].value,
          isError: currentData[switchIdLeft4].errorLevel,
          textOn: "手动",
          textOff: "自动",
        };

        const switchIdRight1 = this.findDeviceId(this.switchTitleRight1);
        const switchIdRight2 = this.findDeviceId(this.switchTitleRight2);
        const switchIdRight3 = this.findDeviceId(this.switchTitleRight3);
        this.switchDataRight1 = {
          data: currentData[switchIdRight1].value,
          isError: currentData[switchIdRight1].errorLevel,
          isZh: true,
        };
        this.switchDataRight2 = {
          data: currentData[switchIdRight2].value,
          isError: currentData[switchIdRight2].errorLevel,
          isZh: true,
        };
        this.switchDataRight3 = {
          data: currentData[switchIdRight3].value,
          isError: currentData[switchIdRight3].errorLevel,
          textOn: "远程",
          textOff: "就地",
        };

        const runningTimeIdLeft = this.findDeviceId(this.runningTimeTitleLeft);
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;

        const runningTimeIdRight = this.findDeviceId(this.runningTimeTitleRight);
        this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-small {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }

    .device-block-multi-item {
      background-color: rgba(255, 255, 255, 0.6);
      width: calc((100% / 4) - 10px);
    }

    .device-block-line-item {
      width: calc(50% - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 140px;
        width: 100%;
      }

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        flex-shrink: 0;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .device-block-time-left {
        height: calc(100% - 190px);
        width: 100%;
        box-sizing: border-box;
      }

      .device-block-time-right {
        height: calc(100% - 140px);
        width: 100%;
        box-sizing: border-box;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 140px;
        width: 100%;
      }

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}
</style>
